import moment from 'moment'
import _ from 'lodash'

export function calculsTransaction(transaction) {
  let elapsed = 0
  let totalBreak = 0
  let totalBillard = 0
  let totalConsos = 0
  let playersCount = 0
  let totalTransfert = 0
  if (transaction.pool) {
    for (let i = 0; i < transaction.pool.cycles.length; i++) {
      if (i === transaction.pool.cycles.length - 1) {
        playersCount = transaction.pool.cycles[i].playersCount
      }
      const totals = calculCycle(transaction.pool.cycles[i])
      totalBillard += totals.total
      elapsed += totals.elapsed
      totalBreak += totals.breakPeriod
    }
    if (transaction.pool.transfert) {
      totalTransfert = Number(transaction.pool.transfert.total)
    }
  }
  totalConsos = calculTotalConsos(transaction)
  return {
    total: _.round(totalBillard + totalTransfert, 1) + totalConsos,
    totalBillard: _.round(totalBillard + totalTransfert, 1),
    totalCurrentBillard: _.round(totalBillard, 1),
    totalTransfert: totalTransfert,
    totalProducts: totalConsos,
    elapsed: elapsed,
    playersCount: playersCount,
    totalBreak: totalBreak
  }
}
export function calculCycle(cycle) {
  let total = 0
  const { pricing, players } = cycle
  const endDate = cycle.endDate
    ? moment(cycle.endDate)
    : cycle.pauseDate
      ? moment(cycle.pauseDate)
      : moment()
  let elapsed = endDate.diff(moment(cycle.startDate)) - cycle.breakPeriod
  if (pricing.type === 0) {
    const hours = (elapsed / (1000 * 60 * 60)) % 24
    const pricePerPlayer =
      !cycle.playersCount || cycle.playersCount === 0
        ? 0
        : hours * pricing.value / cycle.playersCount
    for (let i = 0; i < players.length; i++) {
      const p = players[i]
      total += p.count * (pricePerPlayer - pricePerPlayer * p.reduc / 100)
    }
  } else if (pricing.type === 1) {
    for (let i = 0; i < players.length; i++) {
      const p = players[i]
      total +=
        _.round(
          Number(pricing.value) - Number(pricing.value) * p.reduc / 100,
          1
        ) * p.count
    }
  }
  return {
    total: _.round(total, 1),
    elapsed: elapsed,
    breakPeriod: cycle.breakPeriod
  }
}
export function calculTotalBillard(transaction) {
  let total = 0
  for (let i = 0; i < transaction.pool.cycles.length; i++) {
    total += calculCycle(transaction.pool.cycles[i]).total
  }
  return _.round(total, 1)
}

export function calculTotalConsos(transaction) {
  let total = 0
  if (transaction.products) {
    const productsArray = Object.keys(transaction.products).map(key => ({
      ...transaction.products[key],
      key: key
    }))
    productsArray.forEach(product => {
      total += Number(product.price)
    })
  }
  return total
}
export function calculTotalBillardConsos(transaction, currentPricing) {
  let total = calculTotalBillard(transaction, currentPricing)
  total +=
    transaction.pool && transaction.pool.transfert
      ? Number(transaction.pool.transfert.total)
      : 0
  total += calculTotalConsos(transaction)
  return total
}



// WEBPACK FOOTER //
// ./src/utils/PriceCalculHelpers.js